import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ContactModel} from '../../models/contact.model';

@Component({
    selector: 'app-add-contact',
    templateUrl: './add-contact.page.html',
    styleUrls: ['./add-contact.page.scss'],
})
export class AddContactPage implements OnInit {

    @Input() contact: ContactModel;
    
    

    constructor(public modalController: ModalController) {
    }

    ngOnInit() {
        if( !this.contact ){
            this.contact = new ContactModel();
        }
    }

    async saveContact() {
        if (!this.contact.name || this.contact.name === '') {
            alert('Please add a name for the contact');
        } else {
            await this.modalController.dismiss(this.contact);
        }
    }

}
